<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-100 md-size-40">
      <target-filters
        v-on:applyFilters="loadData"
        v-model="filters"
      ></target-filters>
    </div>
    <div class="md-layout-item md-size-100">
      <target-table-data
        ref="table"
        :endpoints="endpoints"
        :getCellAttrs="getCellAttrs"
        :units="units"
        paginationEnabled
      >
        <template v-slot:headers="{ data, filters }">
          <md-table-head colspan="2">Anticipation</md-table-head>
          <md-table-head
            v-for="header in getHeaders(data)"
            :key="header"
            class="md-table-head border-right flex-100"
          >
            <div class="w-100 text-center">{{ header }}</div>
            <div class="d-flex justify-around">
              <!--  eslint-disable-next-line -->
              <div class="label" v-if="filters.targets.includes('OCCUPANCY')">% Occ</div>
              <!--  eslint-disable-next-line -->
              <div class="label" v-if="filters.targets.includes('ONLINE_OCCUPANCY')">% Online</div>
              <!--  eslint-disable-next-line -->
              <div class="label" v-if="filters.targets.includes('ADR')">ADR</div>
            </div>
          </md-table-head>
        </template>
      </target-table-data>
    </div>
  </div>
</template>

<script>
import TargetTableData from "./Components/ComputedTable.vue";
import TargetFilters from "./Components/TargetFilters.vue";

import TargetOccupancyApi from "../../../../openapi/src/api/TargetOccupancyApi";
import TargetOccupancyDataDTO from "../../../../openapi/src/model/TargetOccupancyDataDTO";

const api = new TargetOccupancyApi();

export default {
  components: {
    TargetFilters,
    TargetTableData
  },
  data() {
    return {
      units: { occupancy: "%", adr: "€", online_occupancy: "%" },
      filters: null,
      endpoints: {
        compute: api.computeTargetOccupancy.bind(api),
        save: api.saveTargetOccupancy.bind(api),
        create: data => TargetOccupancyDataDTO.constructFromObject(data)
      }
    };
  },
  methods: {
    getCellAttrs(filters) {
      var cells = [];
      if (filters.targets.includes("OCCUPANCY")) cells.push("occupancy");
      // eslint-disable-next-line
      if (filters.targets.includes("ONLINE_OCCUPANCY")) cells.push("online_occupancy");
      if (filters.targets.includes("ADR")) cells.push("adr");

      return cells;
    },
    getHeaders(data) {
      return data && data.rows && data.rows.length
        ? data.rows[0].columns.map(c => c.anticipation_days)
        : [];
    },
    loadData(filters) {
      this.filters = filters;
      this.$refs["table"].loadData(filters);
    }
  }
};
</script>
